import styled from "styled-components";
import { responsive } from "../../../../../styles/constants.style";

export const BulkActivitySearchParticipantsWrapper = styled.div`
  .MuiPickersTextField-root,
  .MuiPickersInputBase-root {
    width: 100%;
  }
  .form-container {
    padding: 0 0 0 16px;
    ${responsive.MOBILE`
      padding: 0 8px;
    `}
  }

  .button-container {
    margin: 32px 16px 16px 20px;
    text-align: end;

    ${responsive.MOBILE`
        margin: 16px 8px 16px 8px;
    `}

    button {
      ${responsive.MOBILE`
        width:100%;
        
      `}
    }
  }

  .result-header-container {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .selected-count {
    padding: 1px 8px;
  }

  .search-header-container {
    display: flex;
    justify-content: space-between;

    .reset-all-button {
      padding: 0px 10px;
      height: 40px;

      svg {
        margin-right: 8px;
      }
    }
  }
  .semi-header {
    display: flex;
    padding: 16px 16px 16px 16px;
    justify-content: flex-end;
  }
`;
